
import { defineComponent, ref, Ref } from 'vue';
import router from '@/router';
import store from '@/store';
import { LoginParams, UserService } from '@/utils/api/user';
import { ElMessage } from 'element-plus';

export default defineComponent({
  setup() {
    const account: Ref<LoginParams> = ref({
      username: '',
      password: '',
    });
    const isAdministrator = ref(false);
    //自定义表单验证
    const loginForm = ref(null);
    const submitForm = () => {
      let flag;
      (loginForm.value as any).validate((valid: boolean) => {
        flag = valid;
      });
      if (flag === true) {
        if (isAdministrator.value === false) {
          UserService.login1(account.value)
            .then((res) => {
              console.log(res);
              if (res.data.a == 8) {
                router.push('main');
                store.commit('login', {
                  isLogin: true,
                  credit: parseInt(res.data.b)/20,
                  isAdministrator: isAdministrator.value,
                  username: account.value.username,
                  password: account.value.password,
                });
              } else if (res.data.a == 7) {
                openError('密码错误！');
              } else if (res.data.a == 14) {
                openError('请输入手机号或者身份证号！');
              } else if (res.data.a == 6) {
                openError('手机号未注册，请先注册！');
              } else if (res.data.a == 10) {
                openError('身份证号未注册，请先注册！');
              } else {
                openError('登录出错，请联系管理员！');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          UserService.login2(account.value)
            .then((res) => {
              console.log(res.data);
              if (res.data.a === 8) {
                store.commit('login', {
                  isLogin: true,
                  isAdministrator: isAdministrator.value,
                  username: account.value.username,
                  password: account.value.password,
                });
                router.push('admin');
              } else if (res.data.a == 15) {
                openError('管理员不存在');
              } else if (res.data.a == 7) {
                openError('密码错误');
              } else {
                openError('系统出错了');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    };
    const checkUsername = (rule: any, value: any, callback: any) => {
      if (!value) {
        return callback(new Error('用户名不能为空'));
      }
      callback();
    };
    const checkPassword = (rule: any, value: any, callback: any) => {
      if (!value) {
        return callback(new Error('密码不能为空'));
      }
      callback();
    };
    const rules = {
      username: [{ validator: checkUsername, trigger: 'change' }],
      password: [{ validator: checkPassword, trigger: 'change' }],
    };

    //状态标志
    const handleSelect = (key: any, keyPath: any) => {
      isAdministrator.value = key === '1' ? false : true;
    };
    // const change1 = () => {
    //   isAdministrator.value = false;
    // };
    // const change2 = () => {
    //   isAdministrator.value = true;
    // };
    //错误提示
    const openError = (inf: string) => {
      ElMessage({
        showClose: true,
        message: inf,
        type: 'error',
        offset: 200,
      });
    };
    return {
      account,
      isAdministrator,
      loginForm,
      submitForm,
      rules,
      // change1,
      // change2,
      handleSelect,
      openError,
    };
  },
});
